const actionTypes = {
  SET_LEARNING_MODE: "seneca/classroom/SET_LEARNING_MODE",
  SET_LEARNING_MODE_META: "seneca/classroom/SET_LEARNING_MODE_META"
};

export default actionTypes;
